import React from "react";

export const Title = ({ title, onClick }: { title: string; onClick: () => void }) => {
  return (
    <div
      className="cw-px-2 cw-pt-1 cw-my-1 cw-pb-1 cw-rounded-lg cw-cursor-pointer hover:cw-bg-default-hover"
      onClick={onClick}
    >
      <div className="cw-flex cw-items-center cw-justify-between cw-gap-[3px] cw-overflow-hidden cw-whitespace-nowrap cw-text-ellipsis cw-w-full">
        <span className="cw-overflow-hidden cw-whitespace-nowrap cw-text-ellipsis cw-body-base cw-text-14 cw-font-semibold cw-text-default">
          {title}
        </span>
      </div>
    </div>
  );
};
